import { useEffect, useState, useRef } from 'react'

import ReceiptIcon from '@mui/icons-material/Receipt'
import {
	Stack,
	Grid,
	Paper,
	Box,
	Button,
	TextField,
	FormControl,
	InputLabel,
	Typography,
	Select,
	SelectChangeEvent,
	useMediaQuery,
	MenuItem,
	Breadcrumbs,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Radio,
	RadioGroup,
	Tooltip,
	TooltipProps,
	tooltipClasses,
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'

import {
	DataGridPremium,
	koKR,
	GridColDef,
	GridSelectionModel,
	GridDensity,
	useGridApiRef,
	GridColumnVisibilityModel,
} from '@mui/x-data-grid-premium'
import { styled, useTheme } from '@mui/material/styles'

import { alertModal, confirmAlert, hexToRgba } from 'util/util'

import { selectuserInfo } from 'hooks/userInfo'
import { selectCmmnCode } from 'hooks/cmmnCodeFactory'
import { useSelector } from 'react-redux'
import {
	generatePdf,
	apiReportDownload,
	apiRptTypeCodeList,
	apiReportTypeList,
	apiReceptionByRptTypeCode,
	apiRptCodeListByReportCode,
	apiSavePrintState,
	apiReportImageSelectByRptTypeCodeAndReceptionId,
} from '../../api/api'
import { extractCmmnCode } from 'util/cmmnCodeUtil'

import moment from 'moment'

import { compareDate, isValidDateType } from 'util/util'
import { compareDateValues } from 'util/stringUtil'
import { getSettings } from 'helpers/storage'
import ReportSlider from 'views/report/ReportSlider'
import React from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import ClientSearchPopup from './clientSearchPopup'

import SimplePopup from 'components/SimplePopup'
import JSZip from 'jszip'

import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import { valuesInIterator } from 'util/objectUtil'
import LinearProgress from '@mui/material/LinearProgress'
import ProgressBar from 'components/ProgressBar'
import { PageBg } from 'components/ComponentStyles'
import { CheckboxWithLabel } from 'formik-mui'

// 리포트 목록 타입
type ReportListType = {
	ReportName: string
	ReportTitle: string
	RptTypeCode: string
}

// 검색 조건 타입
type SearchType = {
	clientID: string // 거래처id
	searchType: string // 검색구분 (R: 접수일자, D:보고일자)
	startDate: string // 시작일자
	endDate: string // 종료일자
	chartNo: string // 차트번호
	patientName: string // 수진자명
	reportTypeCode: string // 보고서 종류
	sortType: string // 정렬구분 (0: 최근의뢰일, 1: 등록일자, 2: 수진자명, 3: 차트번호)
	notPrinted: boolean // 출력대기 자료만 검색
	searchTestType: string // 학부
	downloadType: string // 다운로드 종류 (0: PDF, 1: 이미지)
	isSecured: boolean // 암호화 여부 (PDF 다운로드 시 암호화 여부)
	partCode: string // 학부 코드
	searchD90: boolean // 완료인것만 검색 여부
}

const locales = ['ko'] as const

type partCodeType = {
	partName: string
	partCode: string
}

type rptCodeType = {
	rptTypeCode: string
	reportName: string
	webReportName: string
	partCode: string
	active: boolean
}

const ReportGenerator = styled('div')(({ theme }) => ({
	position: 'fixed',
	top: '0',
	left: '0',
	width: '100%',
	height: '100%',
	backgroundColor:
		theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.8)',
	zIndex: 9999,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
}))

const PageBg2 = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '1rem',
	borderRadius: '0.5rem',
	background: `${hexToRgba(theme.palette.custom.wrapper, 1)}`,
	// filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		flexDirection: 'column',
		borderRadius: 0,
	},
	// backdropFilter: 'blur(10px)',
}))

const PageWrap = styled('div')(({ theme }) => ({
	marginBottom: '1rem',
	position: 'relative',
	top: '0',
	left: '0',
	right: '0',
	zIndex: '110',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		//marginLeft: '-1.5rem',
		//marginRight: '-1.5rem',
		top: '0',
		//borderRadius: '0',
	},
}))

const BtnBox = styled(Box)(({ theme }) => ({
	// [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
	// 	marginTop: '1rem',
	// },
}))

const TitleText = styled(Typography)(({ theme }) => ({
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		display: 'none',
	},
}))

const SearchRowItem = styled(Box)(({ theme }) => ({
	position: 'relative',
	display: 'block',
	paddingLeft: '80px',
	minHeight: '44px',
	marginBottom: '10px',
	'&.noLabel': {
		paddingLeft: '0',
	},
	'.labelText': {
		position: 'absolute',
		left: '10px',
		top: '15px',
		[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
			position: 'relative',
			left: '0',
			top: '0',
			marginBottom: '0.5rem',
		},
	},
	[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
		paddingLeft: '0',
		height: 'auto',
	},
}))

const ResultBatchDownload = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))
	const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

	const grid1Ref = useGridApiRef()

	const [reportIsLoading, setReportIsLoading] = useState<boolean>(false)

	const userInfo = useSelector(selectuserInfo)
	const env = getSettings()
	// ui
	const cmmnCdList = useSelector(selectCmmnCode)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [disabledReset, setDisabledReset] = useState(false)
	const [showImageOverlay, setShowImageOverlay] = useState(false)

	const [dateRange, setDateRange] = useState('1d')
	const [locale, setLocale] = useState<(typeof locales)[number]>('ko')

	const [page1, setPage1] = useState(0)

	// 조회조건 (검체종류)
	const [testCdList, setTestCdList] = useState<any>([])

	// 파트 코드 목록
	const [partCodeList, setPartCodeList] = useState<partCodeType[]>([])
	// 보고서 종류 코드 목록
	const [rptTypeList, setRptTypeList] = useState<rptCodeType[]>([])

	/**
	 * 검체종류 select
	 * @param e
	 */
	const searchTestCdOnChange = (e: SelectChangeEvent<string>): void => {
		const selectedPartCode = e.target.value

		apiRptCodeListByReportCode(selectedPartCode).then((res) => {
			console.log(res)
			setRptTypeList(res)

			setTestSearch((prev) => ({
				...prev,
				partCode: selectedPartCode,
				reportTypeCode: res?.[0]?.rptTypeCode ?? '0',
			}))
		})
	}

	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])
	const [imageList, setImageList] = useState<any>([])

	const actionSearch = () => {
		if (!disabledSearch) getReceptionList()
	}
	const actionReset = () => {
		setTestSearch({
			clientID: userInfo.infoType === 'C' ? userInfo.clientID : '', // 거래처id
			searchType: 'R', // 검색구분 (R: 접수일자, D:보고일자)
			startDate: moment(new Date()).isBefore('2023-08-01')
				? moment('2023-08-01').format('yyyy-MM-DD')
				: moment().subtract(1, 'days').format('YYYY-MM-DD'), // 시작일자
			endDate: moment().format('YYYY-MM-DD'), // 종료일자
			chartNo: '', // 차트번호
			patientName: '', // 수진자명
			reportTypeCode: '0', // 보고서 종류
			sortType: '0', // 정렬구분 (0: 최근의뢰일, 1: 등록일자, 2: 수진자명, 3: 차트번호)
			notPrinted: false, // 출력대기 자료만 검색
			searchTestType: '0', // 학부
			downloadType: 'PDF', // 다운로드 종류 (0: PDF, 1: 이미지)
			isSecured: false, // 암호화 여부 (PDF 다운로드 시 암호화 여부)
			partCode: '0', // 학부 코드
			searchD90: false, // 완료인것만 검색 여부
		})
		setSearchClientName('')
		setDateRange('1d')
		actionSearch()
		grid1Ref.current?.setQuickFilterValues([])
		grid1Ref.current?.setPage(0)
	}

	const [imageDataList, setImageDataList] = useState<any>([])
	const [reportDialog, setReportDialog] = useState(false)

	// calcaulate today before n days
	const getBeforeDate = (n: number) => {
		setTestSearch({
			...testSearch,
			startDate: moment(testSearch.endDate)
				.subtract(n, 'days')
				.format('YYYY-MM-DD'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1d':
				getBeforeDate(1)
				break
			case '3d':
				getBeforeDate(3)
				break
			case '7d':
				getBeforeDate(7)
				break
			case '14d':
				getBeforeDate(14)
				break
			default:
				getBeforeDate(7)
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// date picker on change event

	const dateRanageOnChange = (e: any, target: string) => {
		// setIsDateRangeChanged(false)
		if (moment(new Date(e)).isBefore('2023-08-01')) {
			alertModal('2023-08-01 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setTestSearch({
				...testSearch,
				[target]: moment(new Date(e)).format('yyyy-MM-DD'),
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM-DD').length === 10) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, testSearch.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})
						setDisabledSearch(true)

						setTestSearch((prevState) => {
							return {
								...testSearch,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue < -1825) {
						alertModal('검색기간은 5년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, testSearch.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)

						setTestSearch((prevState) => {
							return {
								...testSearch,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue > 1825) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				}

				setDisabledSearch(false)

				setTestSearch((prevState) => {
					return {
						...testSearch,
						[target]: moment(new Date(e)).format('yyyy-MM-DD'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	const reportImageAction = () => {
		const datas = grid1Ref.current?.getSelectedRows()
		const iterArray = valuesInIterator(datas)
		if (iterArray.length === 0) {
			alertModal('출력할 항목을 선택해주세요.', 'error', () => {})
			return
		}

		if (pdfLimit > 0 && iterArray.length > pdfLimit) {
			alertModal(`${pdfLimit}건 이상은 출력할 수 없습니다.`, 'error', () => {})
			return
		}

		const decodeBase64ToBlob = (dataUrl: string, fileExtension: string) => {
			const base64 = dataUrl?.split(',')[1]
			if (!base64) {
				throw new Error('이미지 데이터가 없습니다.')
			}
			const byteCharacters = atob(base64)
			const byteNumbers = new Array(byteCharacters.length)
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i)
			}
			return new Blob([new Uint8Array(byteNumbers)], { type: fileExtension })
		}
		const triggerDownload = (blob: Blob, fileName: string) => {
			const downloadLink = document.createElement('a')
			const objectUrl = URL.createObjectURL(blob)
			downloadLink.href = objectUrl
			downloadLink.download = fileName
			downloadLink.click()
			downloadLink.remove()
			URL.revokeObjectURL(objectUrl)
		}
		const makeFileName = (item: any, sequence?: number, groupedName?: string) => {
			// 수날짜_차트번호_접수번호_환자이름
			const receptionDate = item.ReceptionDate ? `${item.ReceptionDate}_` : ''
			const chartNo = item.ChartNo ? `${item.ChartNo}_` : ''
			const receptionRegNum = item.ReceptionRegNum
				? `${item.ReceptionRegNum}_`
				: ''
			const patientName = (groupedName || item.PatientName) + '_'
			const ReportTitle = item.ReportTitle ? `${item.ReportTitle}_` : ''
			console.log('====== 파일명 생성 정보 ======')
			console.table({
				receptionDate,
				chartNo,
				receptionRegNum,
				patientName,
				ReportTitle,
			})
			console.log(item)
			console.log('==========================')
			sequence = sequence || 0
			let seqStr = sequence < 10 ? `0${sequence}` : `${sequence}`
			console.log(seqStr)
			return `${receptionDate}${receptionRegNum}${chartNo}${patientName}${ReportTitle}${seqStr}.${item.FileExtension}`
		}

		// interArray에서 imageCount가 0 이상인것과 0인것을 별도 배열에 저장한다.
		const withImageArray = iterArray.filter((item: any) => item.ImageCount > 0)
		const withoutImageArray = iterArray.filter(
			(item: any) => item.ImageCount === 0,
		)

		console.log('withImageArray', withImageArray)
		console.log('withoutImageArray', withoutImageArray)

		const downloadImages = async () => {
			setReportIsLoading(true)
			Promise.all(
				withImageArray.map(async (element: any) => {
					const request = {
						receptionID: element.ReceptionID,
						rptTypeCode: element.RptTypeCode,
					}
					const res = await apiReportImageSelectByRptTypeCodeAndReceptionId(
						request.rptTypeCode,
						request.receptionID,
					)
					return res || []
				}),
			)
				.then(async (results) => {
					const allList = results.flat()
					if (allList.length === 0) {
						alertModal('리포트가 없습니다.', 'error', () => {})
						return
					}
					const zip = new JSZip()
					const fileNameCounter: Record<string, number> = {}
					let sequence = 0
					let groupedName = ''
					let prevRptTypeCode = ''
					allList.forEach((item: any) => {
						console.log(item)
						// 아래의 경우에 sequence 초기화
						// 수진자명이 달라지면 초기화, 수진자 명이 같지만 rptTypeCode가 달라지면 초기화
						if (groupedName !== item.PatientName) {
							groupedName = item.PatientName
							sequence = 0
							prevRptTypeCode = item.RptTypeCode
						} else if (
							groupedName === item.PatientName &&
							prevRptTypeCode !== item.RptTypeCode
						) {
							sequence = 0
							prevRptTypeCode = item.RptTypeCode
						}
						const blob = decodeBase64ToBlob(item.URL, item.FileExtension)
						sequence += 1
						const finalFileName = makeFileName(item, sequence, groupedName)
						// fileNameCounter[originalFileName] =
						// 	(fileNameCounter[originalFileName] || 0) + 1
						// const duplicateCount = fileNameCounter[originalFileName]
						// const finalFileName =
						// 	duplicateCount > 1
						// 		? `${duplicateCount}_${originalFileName}`
						// 		: originalFileName
						zip.file(finalFileName, blob)
					})
					const content = await zip.generateAsync({ type: 'blob' })
					const zipFileName = `JPG_${moment().format('YYYYMMDD')}`
					triggerDownload(content, `${zipFileName}.zip`)
					savePrintState('IMAGE')
				})
				.catch((error) => {
					console.log(error)
					alertModal('이미지 다운로드에 실패했습니다.', 'error', () => {})
				})
				.finally(() => {
					setReportIsLoading(false)
					setDownloadProgress(0)
				})
		}

		if (withoutImageArray.length > 0) {
			console.log('알림창 출력 후 받는다')
			// 환자 정보를 아래와 같이 생성 후 모달에 출력한다.
			// ReceptionDate PatientName(ChartNo) ReportTitle
			// 단 ReceptionDate 표기는 6/13 과 같이 표기
			const patientInfoList = withoutImageArray.map((item: any) => {
				const receptionDate = item.ReceptionDate
					? moment(item.ReceptionDate).format('M/D')
					: ''
				const patientName = item.PatientName || ''
				const chartNo = item.ChartNo ? `(${item.ChartNo})` : ''
				const reportTitle = item.ReportTitle ? ` ${item.ReportTitle}` : ''
				return `${receptionDate} ${patientName}${chartNo}${reportTitle}`
			})
			// 위의 patientInfoList를 줄바꿈으로 구분하여 모달에 출력한다.
			alertModal(
				`보고서 이미지 생성 중입니다.<br/>${patientInfoList.join('<br/>')}`,
				'info',
				() => {
					downloadImages()
				},
			)
		} else {
			console.log('그냥 받는다.')
			downloadImages()
		}
	}

	// api response
	const [receptionListData, setReceptionListData] = useState([])
	const [size1, setSize1] = useState(env.row ? env.row : 100)
	const [grid1isLoading, setGrid1isLoading] = useState(false)

	// 검색조건
	const [testSearch, setTestSearch] = useState<SearchType>({
		clientID: userInfo.infoType === 'C' ? userInfo.clientID : '', // 거래처id
		searchType: 'R', // 검색구분 (R: 접수일자, D:보고일자)
		startDate: moment(new Date()).isBefore('2023-08-01')
			? moment('2023-08-01').format('yyyy-MM-DD')
			: moment().subtract(1, 'days').format('YYYY-MM-DD'), // 시작일자
		endDate: moment().format('YYYY-MM-DD'), // 종료일자
		chartNo: '', // 차트번호
		patientName: '', // 수진자명
		reportTypeCode: '0', // 보고서 종류
		sortType: '0', // 정렬구분 (0: 최근의뢰일, 1: 등록일자, 2: 수진자명, 3: 차트번호)
		notPrinted: false, // 출력대기 자료만 검색
		searchTestType: '0', // 학부
		downloadType: 'PDF', // 다운로드 종류 (0: PDF, 1: 이미지)
		isSecured: false, // 암호화 여부 (PDF 다운로드 시 암호화 여부)
		partCode: '0', // 학부
		searchD90: false, // 완료인것만 검색 여부
	})

	// main: '#835FED',
	/**
	 * 그리드 컬럼
	 */
	const columns: GridColDef[] = [
		{
			field: 'ReceptionID',
			headerName: '접수ID',
			type: 'string',
			width: 80,
			editable: false,
			hide: true,
			disableColumnMenu: true,
			headerAlign: 'center',
		},
		{
			field: 'ReceptionDate',
			headerName: '접수일자',
			width: 100,
			disableColumnMenu: true,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'ReceptionRegNum',
			headerName: '접수번호',
			width: 100,
			disableColumnMenu: true,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'PatientName',
			headerName: '수진자명',
			type: 'string',
			width: 250,
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
		},
		{
			field: 'PatientAge',
			headerName: '나이',
			type: 'string',
			width: 70,
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'Gender',
			headerName: '성별',
			type: 'string',
			width: 70,
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'ChartNo',
			headerName: '차트번호',
			type: 'string',
			width: 150,
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
		},
		{
			field: 'ReportTitle',
			headerName: '보고서',
			type: 'string',
			width: 300,
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
		},
		{
			field: 'StateCategory',
			headerName: '상태',
			type: 'string',
			width: 100,
			editable: false,
			align: 'center',
			disableColumnMenu: true,
			headerAlign: 'center',
			renderCell: (params) => {
				const { StateCategory } = params.row
				if (StateCategory === '접수') {
					return (
						<span
							style={{
								background: '#8d8d8d',
								padding: '1px 3px',
								border: '1px solid #8d8d8d',
								color: '#fff',
								width: '100%',
								display: 'block',
								textAlign: 'center',
								borderRadius: '10px',
							}}
						>
							접수
						</span>
					)
				} else if (StateCategory === '재검') {
					return (
						<span
							style={{
								background: '#e67e22',
								padding: '1px 3px',
								border: '1px solid #e67e22',
								color: '#fff',
								width: '100%',
								display: 'block',
								textAlign: 'center',
								borderRadius: '10px',
							}}
						>
							재검
						</span>
					)
				} else if (StateCategory === '완료') {
					return (
						<span
							style={{
								color: '#000',
								background: '#74acdb',
								padding: '1px 3px',
								border: '1px solid #74acdb',
								width: '100%',
								display: 'block',
								textAlign: 'center',
								borderRadius: '10px',
							}}
						>
							완료
						</span>
					)
				} else if (StateCategory === '완료') {
					return (
						<span
							style={{
								color: '#000',
								background: '#99d696',
								padding: '1px 3px',
								border: '1px solid #99d696',
								width: '100%',
								display: 'block',
								textAlign: 'center',
								borderRadius: '10px',
							}}
						>
							진행
						</span>
					)
				} else if (StateCategory === '진행') {
					return (
						<span
							style={{
								color: '#000',
								background: '#99d696',
								padding: '1px 3px',
								border: '1px solid #99d696',
								width: '100%',
								display: 'block',
								textAlign: 'center',
								borderRadius: '10px',
							}}
						>
							진행
						</span>
					)
				}
			},
		},
		{
			field: 'D90',
			headerName: '보고일',
			type: 'string',
			width: 130,
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
			align: 'center',
			renderCell: (params) => {
				const { D90, StateCategory } = params.row
				return <>{StateCategory === '완료' && D90 && <span>{D90}</span>}</>
			},
		},
		{
			field: 'PrintState',
			headerName: '출력',
			type: 'string',
			width: 100,
			editable: false,
			align: 'center',
			disableColumnMenu: true,
			headerAlign: 'center',
			renderCell: (params) => {
				const { PrintDate } = params.row
				return <>{PrintDate && '출력'}</>
			},
		},
		{
			field: 'PrintDate',
			headerName: '출력일시',
			type: 'string',
			width: 150,
			align: 'center',
			editable: false,
			disableColumnMenu: true,
			headerAlign: 'center',
			renderCell: (params) => {
				const { PrintDate } = params.row
				console.log('PrintDate', PrintDate)
				return <>{PrintDate && moment(PrintDate).format('YYYY-MM-DD HH:mm:ss')}</>
			},
		},
		// {
		// 	field: 'ImageCount',
		// 	headerName: '',
		// 	type: 'string',
		// 	width: 200,
		// 	align: 'center',
		// 	editable: false,
		// 	disableColumnMenu: true,
		// 	renderCell: (params) => {
		// 		const { ImageCount } = params.row
		// 		return (
		// 			<>
		// 				{ImageCount === 0 &&
		// 					testSearch.downloadType !== 'PDF' &&
		// 					'보고서 이미지 생성중입니다.'}
		// 			</>
		// 		)
		// 	},
		// },
	]

	// 수진자 목록
	const getReceptionList = (searchValue: SearchType = testSearch) => {
		// 내부사용자이고 clientID가 없으면
		if (
			(userInfo.infoType === 'S' || userInfo.infoType === 'W') &&
			searchValue.clientID === ''
		) {
			alertModal('거래처를 선택해주세요.', 'error', () => {})
			return
		}

		// if testSearch.startDate less then 2023-08-01 then startDate = 2023-08-01
		if (moment(searchValue.startDate).isBefore('2023-08-01')) {
			setTestSearch({
				...searchValue,
				startDate: '2023-08-01',
			})
		}

		let dateCompare = true

		// 거래처일 경우 날짜 체크
		if (userInfo.infoType === 'C') {
			dateCompare = compareDateValues(searchValue.startDate, searchValue.endDate)
		}
		// 관리자일 경우 종료일이 시작일보다 이전인지만 체크
		if (userInfo.infoType === 'S' || userInfo.infoType === 'W') {
			if (moment(searchValue.endDate).isBefore(searchValue.startDate)) {
				dateCompare = false
				alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
				return
			}
		}

		// if (testSearch.partCode === '0') {
		// 	alertModal('학부를 선택해주세요.', 'error', () => {})
		// 	return
		// }

		// if (testSearch.reportTypeCode === '0') {
		// 	alertModal('보고서 종류를 선택해주세요.', 'error', () => {})
		// 	return
		// }

		if (dateCompare) {
			setReceptionListData([])

			setDisabledSearch(true)
			const request = {
				clientID: searchValue.clientID as any,
				searchType: searchValue.searchType,
				startDate: searchValue.startDate,
				endDate: searchValue.endDate,
				chartNo: searchValue.chartNo,
				patientName: searchValue.patientName,
				reportTypeCode:
					searchValue.reportTypeCode === '0' ? '' : searchValue.reportTypeCode,
				sortType: searchValue.sortType,
				notPrinted: searchValue.notPrinted ? '1' : '0',
				downloadType: searchValue.downloadType,
				isSecured: '1',
				searchD90: searchValue.searchD90 ? '1' : '0',
			}

			grid1Ref.current?.setSelectionModel([])
			grid1Ref.current?.setPage(0)

			setGrid1isLoading(true)
			apiReceptionByRptTypeCode(request)
				.then((res) => {
					console.log(res)
					setReceptionListData(res)
				})
				.finally(() => {
					setGrid1isLoading(false)
					window.scrollTo({ top: 0, behavior: 'smooth' })
					setDisabledSearch(false)
				})
		}
	}

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	const reportClose = () => {
		setReportDialog(false)
		setImageDataList([])
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		console.log(e)
		setSearchClientName(e.ClientName)
		setTestSearch({
			...testSearch,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	const downloadCount = useRef<number>(0)
	const [downloadProgress, setDownloadProgress] = useState(0)
	// 프로그레스바에 출력할 텍스트 내용
	const [progressText, setProgressText] = useState('')

	// PDF 출력 다건 출력
	const reportPrintActionByPdf = async () => {
		confirmAlert(
			'출력할 항목이 많을 경우 시간이 소요 될 수 있습니다.',
			async () => {
				setProgressText('데이터 조회중입니다.')
				const datas = grid1Ref.current?.getSelectedRows()
				const iterArray = valuesInIterator(datas)
				if (iterArray.length === 0) {
					alertModal('출력할 항목을 선택해주세요.', 'error', () => {})
					return
				}

				downloadCount.current = 0
				setDownloadProgress(0)

				// pdfLimit 값보다 많으면 경고창
				if (pdfLimit > 0 && iterArray.length > pdfLimit) {
					alertModal(`${pdfLimit}건 이상은 출력할 수 없습니다.`, 'error', () => {})
					return
				}

				setReportIsLoading(true)

				Promise.all(
					iterArray.map(async (element: any) => {
						const request = {
							receptionID: element.ReceptionID,
							clientID:
								userInfo.infoType === 'S' || userInfo.infoType === 'W'
									? testSearch.clientID
									: userInfo.clientID,
							rptTypeCode: element.RptTypeCode,
							usePassword: testSearch.isSecured,
							reportTitle: element.ReportTitle,
						}

						console.log(request)

						setProgressText(
							`${element?.PatientName ? element.PatientName : ''}${
								element?.ChartNo ? `(${element.ChartNo})` : ''
							} 변환 중입니다. (${downloadCount.current + 1}/${iterArray.length})`,
						)

						const result = await apiReportDownload(request, element).catch(() => {
							alertModal(
								`${element.PatientName}(${element.ChartNo}) 리포트 다운로드에 실패했습니다.`,
								'error',
								() => {},
							)
							return null
						})

						downloadCount.current += 1
						setDownloadProgress(
							Math.round((downloadCount.current / iterArray.length) * 100),
						)

						return result
					}),
				)
					.then(async (results) => {
						const resultDataBlob = results.filter(
							(item): item is NonNullable<typeof item> => Boolean(item?.data),
						)

						if (resultDataBlob.length === 0) {
							return
						}

						setProgressText('리포트 변환 완료. 다운로드 중입니다.')

						const zip = new JSZip()
						const fileNameCounter: Record<string, number> = {}

						for (const item of resultDataBlob) {
							const blob = new Blob([item.data], { type: 'application/pdf' })
							const header = item.headers['content-disposition']
							const match = header?.match(/filename=([^;]+)/)
							const encodedFileName = match?.[1]
							const decodedFileName = encodedFileName
								? decodeURIComponent(encodedFileName)
								: 'downloaded-file.pdf'

							fileNameCounter[decodedFileName] =
								(fileNameCounter[decodedFileName] || 0) + 1
							const duplicateCount = fileNameCounter[decodedFileName]
							const lastDotIndex = decodedFileName.lastIndexOf('.')
							const baseFileName =
								lastDotIndex > -1
									? decodedFileName.slice(0, lastDotIndex)
									: decodedFileName
							const fileExtension =
								lastDotIndex > -1 ? decodedFileName.slice(lastDotIndex) : ''
							const finalFileName =
								duplicateCount > 1
									? `${baseFileName}_${duplicateCount}${fileExtension}`
									: decodedFileName

							zip.file(finalFileName, blob)
						}

						const content = await zip.generateAsync({ type: 'blob' })
						const downloadLink = document.createElement('a')
						const objectUrl = URL.createObjectURL(content)
						downloadLink.href = objectUrl
						downloadLink.download = `PDF_${moment().format('YYYYMMDD')}.zip`
						downloadLink.click()
						downloadLink.remove()
						URL.revokeObjectURL(objectUrl)

						savePrintState('PDF')
					})
					.finally(() => {
						setReportIsLoading(false)
						setDownloadProgress(0)
						downloadCount.current = 0
						setProgressText('')
					})
			},
			() => {},
		)
	}

	const [columnVisibilityModel, setColumnVisibilityModel] =
		React.useState<GridColumnVisibilityModel>({
			ReceptionID: false,
			rowNum: true,
			ReceptionDate: true,
			ReceptionInfo: true,
			PatientName: true,
			ChartNo: true,
			ClientInfo: true,
			DepartName: true,
			PartName: true,
			RptTypeName:
				userInfo.clientID === 6499 ||
				userInfo.clientID === 6502 ||
				userInfo.infoType === 'S' ||
				userInfo.infoType === 'W'
					? true
					: false,
			FindingsCnt: false,
			StateCategory: true,
			Decision: true,
			isView: true,
		})

	// 검사결과 그리드의 결과 버튼 처리
	const [resultTitle, setResultTitle] = useState<string>('')
	const [resultPopupOpen, setResultPopupOpen] = useState(false)
	const [resultPopupText, setResultPopupText] = useState<string>('')

	const resultPopupClose = () => {
		setResultPopupOpen(false)
		setResultTitle('')
		setResultPopupText('')
	}

	const [pdfLimit, setPdfLimit] = useState(0)

	const [reportTypeList, setReportTypeList] = useState<ReportListType[]>([])

	const reportAction = () => {
		if (testSearch.downloadType === 'PDF') {
			reportPrintActionByPdf()
		} else {
			reportImageAction()
		}
	}

	const savePrintState = (downloadType: 'PDF' | 'IMAGE') => {
		const datas = grid1Ref.current?.getSelectedRows()
		const iterArray = valuesInIterator(datas)
		if (iterArray.length === 0) {
			return
		}

		// interArray에서 imageCount가 0 이상인것과 0인것을 별도 배열에 저장한다.
		const withImageArray = iterArray.filter((item: any) => item.ImageCount > 0)

		let json: any[] = []

		if (downloadType === 'PDF') {
			json = iterArray.map((item: any) => {
				return {
					rptTypeCode: item.RptTypeCode,
					downloadType: testSearch.downloadType,
					receptionID: item.ReceptionID,
				}
			})
		} else if (downloadType === 'IMAGE') {
			json = withImageArray.map((item: any) => {
				return {
					rptTypeCode: item.RptTypeCode,
					downloadType: testSearch.downloadType,
					receptionID: item.ReceptionID,
				}
			})
		}
		console.log(json)
		const request = {
			clientID:
				userInfo.infoType === 'S' || userInfo.infoType === 'W'
					? testSearch.clientID
					: userInfo.clientID,
			json: json,
		}
		apiSavePrintState(request).then((res) => {
			console.log(res)
		})
	}

	useEffect(() => {
		console.log(userInfo)
		console.log(userInfo.infoType === 'W' || userInfo.infoType === 'S')
		// 사용자 타입이 거래처일 경우만 자동 조회
		if (userInfo.infoType === 'C') getReceptionList()
		// 검색조건의 공통코드
		// const lv2 = extractCmmnCode(cmmnCdList, 'TEST_CD', 1)
		// setTestCdList(lv2?.level2)
		// setTestSearch({
		// 	...testSearch,
		// 	partCode: '0',
		// })
		const pdflv2 = extractCmmnCode(cmmnCdList, 'PDF_LIMIT', 1)
		console.log(pdflv2?.level2[0].cmmnCd)
		setPdfLimit(Number(pdflv2?.level2[0].cmmnCd))

		apiReportTypeList().then((res) => {
			console.log(res)
			setTestCdList(res)
		})

		apiRptCodeListByReportCode('0').then((res) => {
			console.log(res)
			setRptTypeList(res)
		})
	}, [])

	return (
		<>
			{reportIsLoading && (
				<ReportGenerator>
					<Box sx={{ width: '300px' }}>
						<ProgressBar
							value={downloadProgress}
							label={progressText}
						/>
					</Box>
				</ReportGenerator>
			)}
			{showImageOverlay && (
				<ReportSlider
					imageList={imageList}
					reportDialog={reportDialog}
					reportClose={reportClose}
				/>
			)}
			<SimplePopup
				title={resultTitle}
				message={resultPopupText}
				simplePopupOpen={resultPopupOpen}
				simplePopupClose={resultPopupClose}
				isHTML={false}
			/>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								보고서 이미지
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										color="primary"
										variant="contained"
										startIcon={<ContentPasteSearchTwoToneIcon />}
										onClick={actionSearch}
										size="small"
										disabled={disabledSearch}
										sx={{ marginRight: '0.5rem' }}
									>
										조회
									</Button>
								</span>
								<span>
									<Button
										color="secondary"
										size="small"
										variant="contained"
										startIcon={<ReceiptIcon />}
										sx={{ marginRight: '0.5rem' }}
										onClick={reportAction}
										// disabled={isRptType0 ? true : false}
									>
										다운로드
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="searchType-select-label">기간 유형</InputLabel>
										<Select
											labelId="searchType-select-label"
											id="searchTypee-simple-select"
											value={testSearch.searchType}
											label="기간 유형"
											onChange={(e) => {
												setTestSearch({
													...testSearch,
													searchType: e.target.value,
												})
											}}
											size={'small'}
										>
											<MenuItem value={'R'}>접수일자</MenuItem>
											<MenuItem value={'D'}>보고일자</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="시작일"
										value={testSearch.startDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'startDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="종료일"
										value={testSearch.endDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'endDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									{isLgUp ? (
										<>
											<FormControl sx={{ pt: 0.8 }}>
												<RadioGroup
													row
													aria-labelledby="date-controlled-radio-buttons-group"
													name="date-radio-buttons-group"
													value={dateRange}
													onChange={searchDateRanageOnChange}
													sx={{ ml: '0.5rem' }}
												>
													<FormControlLabel
														value="1d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="1일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="3d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="3일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="7d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="7일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="14d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="14일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
												</RadioGroup>
											</FormControl>
										</>
									) : (
										<>
											<FormControl fullWidth>
												<InputLabel id="date-range-select-label">조회 기간</InputLabel>
												<Select
													labelId="date-range-select-label"
													id="date-range-simple-select"
													value={dateRange}
													label="조회 기간"
													onChange={searchDateRanageOnChange}
													size={'small'}
												>
													<MenuItem value={'0'}>선택하세요.</MenuItem>
													<MenuItem value={'1d'}>1일</MenuItem>
													<MenuItem value={'3d'}>3일</MenuItem>
													<MenuItem value={'7d'}>7일</MenuItem>
													<MenuItem value={'14d'}>14일</MenuItem>
												</Select>
											</FormControl>
										</>
									)}
								</Grid>
							</Grid>
						</SearchRowItem>
						<SearchRowItem>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="차트번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={testSearch.chartNo}
										onChange={(e) => {
											setTestSearch({
												...testSearch,
												chartNo: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="수진자명"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={testSearch.patientName}
										onChange={(e) => {
											setTestSearch({
												...testSearch,
												patientName: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<FormControl fullWidth>
										<InputLabel id="rpt-type-select-label">보고서구분</InputLabel>
										<Select
											labelId="rpt-type-select-label"
											id="rpt-type-simple-select"
											value={testSearch.reportTypeCode}
											label="보고서구분"
											onChange={(e) => {
												setTestSearch({
													...testSearch,
													reportTypeCode: e.target.value,
												})
											}}
											size={'small'}
											MenuProps={{ sx: { maxHeight: 655 } }} // add this line
										>
											{testSearch.partCode === '0' && (
												<MenuItem value={'0'}>전체</MenuItem>
											)}
											{rptTypeList &&
												rptTypeList.length > 0 &&
												rptTypeList.map((item: rptCodeType, index: number) => (
													<MenuItem
														key={index}
														value={item.rptTypeCode}
													>
														{item.webReportName}
													</MenuItem>
												))}
										</Select>
									</FormControl>
								</Grid>
								{/* <Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<FormControl fullWidth>
										<InputLabel id="sort-type-select-label">정렬기준</InputLabel>
										<Select
											labelId="sort-type-select-label"
											id="sort-type-simple-select"
											value={testSearch.sortType}
											label="정렬기준"
											onChange={(e) => {
												setTestSearch({
													...testSearch,
													sortType: e.target.value,
												})
											}}
											size={'small'}
										>
											<MenuItem value={'0'}>최근의뢰일</MenuItem>
											<MenuItem value={'1'}>등록일자</MenuItem>
											<MenuItem value={'2'}>수진자명</MenuItem>
											<MenuItem value={'3'}>차트번호</MenuItem>
										</Select>
									</FormControl>
								</Grid> */}
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: isSmDown ? 'flex-end' : 'flex-start',
										}}
									>
										{isSmUp && (
											<Box sx={{ display: 'flex', alignItems: 'center' }}>
												<FormGroup>
													<FormControlLabel
														control={
															<Checkbox
																value={testSearch.notPrinted}
																onChange={(e) => {
																	setTestSearch({
																		...testSearch,
																		notPrinted: e.target.checked,
																	})
																}}
															/>
														}
														label="미출력 조회"
													/>
												</FormGroup>
												<FormGroup>
													<FormControlLabel
														control={
															<Checkbox
																value={testSearch.searchD90}
																onChange={(e) => {
																	setTestSearch({
																		...testSearch,
																		searchD90: e.target.checked,
																	})
																}}
															/>
														}
														label="완료 조회"
													/>
												</FormGroup>
											</Box>
										)}
									</div>
								</Grid>
							</Grid>
							<Grid
								container
								spacing={1}
								sx={{ mt: 0.2 }}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="date-range-select-label">학부</InputLabel>
										<Select
											labelId="date-range-select-label"
											id="date-range-simple-select"
											label="학부"
											value={testSearch.partCode}
											onChange={searchTestCdOnChange}
											size={'small'}
										>
											<MenuItem value={'0'}>전체</MenuItem>
											{testCdList &&
												testCdList.length > 0 &&
												testCdList.map((item: partCodeType) => (
													<MenuItem
														key={item.partCode}
														value={item.partCode}
													>
														{item.partName}
													</MenuItem>
												))}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<FormControl fullWidth>
										<InputLabel id="file-type-select-label">파일형식</InputLabel>
										<Select
											labelId="file-type-select-label"
											id="file-type-simple-select"
											value={testSearch.downloadType}
											label="파일형식"
											onChange={(e) => {
												const selectedDownloadType = e.target.value
												const nextSearch = {
													...testSearch,
													downloadType: selectedDownloadType,
												}

												setTestSearch(nextSearch)

												setReceptionListData([])
												grid1Ref.current?.setSelectionModel([])
												grid1Ref.current?.setPage(0)
												if (nextSearch.clientID || userInfo.clientID) {
													getReceptionList(nextSearch)
												}
											}}
											size={'small'}
										>
											<MenuItem value={'PDF'}>다운로드(PDF)</MenuItem>
											<MenuItem value={'JPG'}>다운로드(JPG)</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								{testSearch.downloadType === 'PDF' && (
									<Grid
										item
										xs={6}
										sm={3}
										md={2}
										lg={2}
									>
										<FormGroup>
											<FormControlLabel
												control={
													<Checkbox
														value={testSearch.isSecured}
														onChange={(e) => {
															setTestSearch({
																...testSearch,
																isSecured: e.target.checked,
															})
														}}
													/>
												}
												label="암호화 여부(생년월일)"
											/>
										</FormGroup>
									</Grid>
								)}
								{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={2}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
								{/* <Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: isSmDown ? 'flex-end' : 'flex-start',
										}}
									>
										{isSmUp && (
											<div>
												<FormGroup>
													<FormControlLabel
														control={
															<Checkbox
																value={testSearch.searchD90}
																onChange={(e) => {
																	setTestSearch({
																		...testSearch,
																		searchD90: e.target.checked,
																	})
																}}
															/>
														}
														label="완료 조회"
													/>
												</FormGroup>
											</div>
										)}
									</div>
								</Grid> */}
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				id="back-to-top"
				elevation={0}
				sx={{
					width: '100%',
					// overflow: 'hidden',
					backgroundColor: 'transparent',
					// overflow: 'auto',
				}}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg style={{ marginTop: '1rem' }}>
							<Typography
								variant="subtitle1"
								component="h3"
								sx={{ lineHeight: '1rem' }}
							>
								수진자 리스트
							</Typography>
							<Box
								sx={{
									marginTop: '1rem',
									height: 813,
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<DataGridPremium
									apiRef={grid1Ref}
									page={page1}
									onPageChange={(newPage) => setPage1(newPage)}
									rows={receptionListData}
									getRowId={(row) => row.rowNum}
									columns={columns}
									getRowClassName={(params) =>
										params.row.StateCategory !== '완료' ? 'no-image-row' : ''
									}
									pageSize={size1}
									onPageSizeChange={(newPageSize) => setSize1(newPageSize)}
									rowsPerPageOptions={[5, 10, 20, 50, 100, 500, 1000]}
									pagination
									autoHeight={false}
									// autoHeight={isLgUp ? true : false}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									components={{
										LoadingOverlay: LinearProgress,
									}}
									isRowSelectable={(params) =>
										params.row.StateCategory === '완료' ? true : false
									}
									loading={grid1isLoading}
									selectionModel={selectionModel}
									onSelectionModelChange={(newSelection) => {
										// console.log(pdfLimit)
										// if (pdfLimit >= newSelection.length) {
										// 	setSelectionModel(newSelection)
										// }
										setSelectionModel(newSelection)
									}}
									density={(env.desnse as GridDensity) || 'compact'}
									checkboxSelection
									sx={{
										'& .MuiDataGrid-columnHeaderTitleContainer': {
											fontSize: '13px',
										},
										'& .MuiDataGrid-row.no-image-row:hover': {
											backgroundColor:
												theme.palette.mode === 'dark'
													? 'rgba(50, 48, 54, 1) !important'
													: '#fff !important',
										},
										'& .MuiDataGrid-row:hover': {
											backgroundColor: 'rgba(0,0,0, 0.1) !important',
										},
										'& .Mui-selected:hover': {
											backgroundColor: 'rgba(75, 123, 236, 0.08) !important',
										},
										'& .MuiDataGrid-cell': {
											fontSize: '13px !important',
											borderRight:
												theme.palette.mode === 'dark'
													? '1px solid rgba(81, 81, 81, 1)'
													: '1px solid rgba(224, 224, 224, 1)',
										},
										'& .Mui-disabled': {
											color: 'rgba(0, 0, 0, 0.1) !important',
										},
									}}
									disableMultipleSelection={false}
									initialState={{
										columns: {
											columnVisibilityModel,
										},
									}}
									onColumnVisibilityModelChange={(newModel) => {
										console.log(newModel)
										setColumnVisibilityModel(newModel)
									}}
								/>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}

export default ResultBatchDownload
